module.exports = __webpack_public_path__ + "img/just-eat.225afe19.png";